import { render, staticRenderFns } from "./ProductionExtendedTable.vue?vue&type=template&id=9af8cf30&scoped=true&"
import script from "./ProductionExtendedTable.vue?vue&type=script&lang=ts&"
export * from "./ProductionExtendedTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionExtendedTable.vue?vue&type=style&index=0&id=9af8cf30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af8cf30",
  null
  
)

export default component.exports